import React from 'react'

const IconSvg = () => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.25'>
      <path
        d='M33.3359 22.917C36.7943 22.917 39.5651 20.1253 39.5651 16.667C39.5651 13.2087 36.7943 10.417 33.3359 10.417C29.8776 10.417 27.0859 13.2087 27.0859 16.667C27.0859 20.1253 29.8776 22.917 33.3359 22.917ZM16.6693 22.917C20.1276 22.917 22.8984 20.1253 22.8984 16.667C22.8984 13.2087 20.1276 10.417 16.6693 10.417C13.2109 10.417 10.4193 13.2087 10.4193 16.667C10.4193 20.1253 13.2109 22.917 16.6693 22.917ZM16.6693 27.0837C11.8151 27.0837 2.08594 29.5212 2.08594 34.3753V39.5837H31.2526V34.3753C31.2526 29.5212 21.5234 27.0837 16.6693 27.0837ZM33.3359 27.0837C32.7318 27.0837 32.0443 27.1253 31.3151 27.1878C33.7318 28.9378 35.4193 31.292 35.4193 34.3753V39.5837H47.9193V34.3753C47.9193 29.5212 38.1901 27.0837 33.3359 27.0837Z'
        fill='#1B1B1D'
      />
    </g>
  </svg>
)

export default IconSvg
